const pricelist = {
  title: "Price List",
  basicMeetingsPackage: {
    title: "A. Basic Meetings Package (10 meetings)",
    description: "To buy any of these packages A1-A6, go to registration page.",
    buttonText: "Go to Registration",
    packages: [
      {
        id: "A1",
        title: <>A1. BUSINESS PARTICIPANT (10 Meetings)</>,
      },

      {
        id: "A2",
        title: <>A2. SECOND BUSINESS PARTICIPANT (with 10-meeting Pack)</>,
      },

      {
        id: "A3",
        title: <>A3. ADDITIONAL MEETING PACK (10 addl meetings)</>,
        buttonText: "Buy Now",
      },

      {
        id: "A5",
        title: <>A5. STARTUP BUSINESS PARTICIPANT (10 meetings)</>,
      },
      {
        id: "A6",
        title: "A6. Casual Visitor",
      },
    ],
  },
  sponsorship: {
    title: "B. Sponsorship",
    buttonDescription: "Select your options and",
    buttonText: "Add to Cart",
    corporateSponsorshipTitle: "Corporate Sponsorship",
    options: {
      B: {
        B1: {
          title: "Platinum Sponsorship (Limited Slots)",
          price: "Rs 8,00,000",
          features: [
            "a.  One 15-min Workshop or Presentation opportunity in the parallel programme.",
            "b.  Company’s logo as Platinum Sponsor displayed at venue, website, Newsletters and Event Guide.",
            "c.  One Full page advertisement in the print and digital Event Guide.",
            "d.  Your company profile (full page) published in the Event Guide.",
            "e.  Video links of all Central Talks will be provided after the Event.",
            "f.  One Premium 12 sqm furnished exhibition booth.",
            "g.  Two Casual Visitor's Passes.",

            <strong>Special Zee Media/ WION benefits:</strong>,

            <>
              h.{" "}
              <strong>
                CEO feature in WION’s Defence Pulse show – Pathfinder features.
              </strong>
            </>,

            <>
              i.{" "}
              <strong>
                Sponsor tag in the Event promo to run on WION/Zee Business/Zee
                News.
              </strong>
            </>,

            <>
              j. <strong>Sponsor tag in the episodic promo.</strong>
            </>,

            <>
              k. <strong>Client aston.</strong>
            </>,

            <>
              l. <strong>Logo presence in the episode slate.</strong>
            </>,

            <>
              m. <strong>Special highlight feature.</strong>
            </>,

            <>
              n. <strong>Brand Mention article.</strong>
            </>,

            <>
              o. <strong>Co-branded social media posts.</strong>
            </>,
          ],
        },
        B2: {
          title: "Gold Sponsorship",
          price: "Rs 6,00,000",
          features: [
            "a.  One 15-min Workshop or Presentation opportunity in the parallel programme.",
            "b.  Company’s logo as Gold Sponsor, displayed at venue, website, Newsletters and Event Guide.",
            "c.  One Full page advertisement in the print and digital Event Guide.",
            "d.  Your company profile (half page) published in the Event Guide.",
            "e.  Video links of all Central Talks will be provided after the Event.",
            "f.  One Pride 6 sqm furnished exhibition booth.",
            "g.  One Casual Visitor's Pass.",

            <strong>Special Zee Media/ WION benefits:</strong>,

            <>
              h.{" "}
              <strong>
                Sponsor tag in the Event promo to run on WION/Zee Business/Zee
                News.
              </strong>
            </>,

            <>
              i. <strong>Sponsor tag in the episodic promo.</strong>
            </>,

            <>
              j. <strong>Logo presence in the promotional aston.</strong>
            </>,

            <>
              k. <strong>Logo presence in the episode slate.</strong>
            </>,

            <>
              l. <strong>Brand Mention article.</strong>
            </>,

            <>
              m. <strong>Co-branded social media posts.</strong>
            </>,
          ],
        },
        B3: {
          title: "Silver Sponsorship",
          price: "Rs 3,75,000",
          features: [
            "a.  Company’s logo as Silver Sponsor displayed at venue, website, Newsletters and Event Guide.",
            "b.  One Half page advertisement in the print and digital Event Guide.",
            "c.  Your company profile (half page) published in the Event Guide.",
            "d.  Video links of all Central Talks will be provided after the Event.",
            "e.  One Eco 4 sqm furnished exhibition booth.",
            "f.  One Casual Visitor's Pass.",

            <strong>Special Zee Media/ WION benefits:</strong>,

            <>
              g.{" "}
              <strong>
                Sponsor tag in the Event promo to run on WION/Zee Business/Zee
                News.
              </strong>
            </>,

            <>
              h. <strong>Sponsor tag in the episodic promo.</strong>
            </>,

            <>
              i. <strong>Logo presence in the episode slate.</strong>
            </>,
          ],
        },
      },
    },
    associationSponsorshipTitle: "Association Sponsorship",
  },
  exhibitingOptions: {
    buttonDescription: "Select your options and",
    buttonText: "Add to Cart",
    title: "C. Exhibiting Options",
    description:
      "Your own booth lets you meet your interlocutors at your own exhibition display booth.",
    options: {
      C: {
        C1: {
          title: "Eco Booth 4sqm",
          description: "Furnished and equipped octonorm booth",
          price: "Rs. 90,000",
          features: [
            // "a. Fascia Name, lights, round table, chairs, carpet, dustbin, electric socket provided.",
            "a. Fascia Name, lights, 1 table, 2 chairs, carpet, dustbin, electric socket provided.",
            "b. Your name is stamped on the map of the event showing location of your stand.",
            "c. Your B2B meetings requested by other participants can be held at your stand.",
            "d. One Casual Visitor's Pass.",
          ],
        },
        C2: {
          title: "Pride Booth 6 sqm ",
          description: "Furnished and equipped octonorm booth",
          price: "Rs. 1,80,000",
          features: [
            "a. Your name is stamped on the map of the event showing location of your stand.",
            "b. Your B2B meetings requested by other participants can be held with the participants at your stand.",
            "c. One Casual Visitor's Pass.",
            "d. Logo and Fascia name, two tables, 4 chairs, carpet, 3 lights, dustbin, electric outlet provided.",
          ],
        },
        C3: {
          // title: "Premium Booth 12 sqm (For Platinum Sponsors Only)",
          title: "Premium Booth 12 sqm ",
          description: "Furnished and equipped octonorm booth",
          price: "Rs. 2,80,000",
          features: [
            "a. Your name is stamped on the map of the event showing location of your stand.",
            "b. Your B2B meetings requested by other participants can be held with the participants at your stand.",
            "c. Two Casual Visitor's Passes.",
            "d. Logo and Fascia name, two tables, 6 chairs, carpet, 6 lights, dustbin, magazine rack, electric outlet provided.",
          ],
        },
        C4: {
          title: "Additional furnishing ",
          description:
            "Available on hire for exhibition booths (transport, installation included) See Section F below",
          features: [
            "Available items include Literature rack, tables, chairs, sofas, showcase, LCD with stand and Printed Flex banners to fully cover walls of your booth with frame.",
          ],
        },
      },
    },
  },
  brandingOptions: {
    buttonDescription: "Select your options and",
    buttonText: "Add to Cart",
    title: "D. Branding options",
    options: {
      D: {
        D1: {
          title: "Registration Sponsor",
          description: "(exclusive)",
          price: "Rs 1,25,000",
          features: [
            "a. Name and Logo of Sponsor displayed across all Regn counters",
            "b. Logo of Sponsor as Regn Sponsor on Stage, Event Guide, Venue Banners, Newsletters",
          ],
          para: "",
        },
        D2: {
          title: "Lanyard Sponsor",
          description: "(non-exclusive, up to 3)",
          price: "Rs 1,25,000",
          features: [
            "a. Logo of Sponsor on every Delegate Lanyard on both sides in colour.",
            "b. Logo of Sponsor as Lanyard Sponsor on Stage, Event Guide, Venue Banners, Newsletters.  Contact IMR for exclusive sponsorship ",
          ],
          para: "",
          sold: true,
        },
        D3: {
          title: "Delegate Folders/Bags Sponsor",
          description: "(exclusive) SOLD",
          price: "Rs 2,50,000",
          features: [
            "a. Logo of Sponsor on each Delegate Folder/Bag.",
            "b. Logo of Sponsor as Delegate Folder Sponsor on Stage, Event Guide, Venue Banners, Newsletters",
          ],
          para: "",
        },
        D4: {
          title: "Name Badge Sponsor",
          description: "(non-exclusive, up to 3)",
          price: "Rs 1,00,000",
          features: [
            "a. Logo of Sponsor on each Delegate Badge",
            "b. Logo of Sponsor as Badge Sponsor on Stage, Event Guide, Venue Banners, Newsletters.  Contact IMR for exclusive sponsorship ",
          ],
          para: "",
          sold: true,
        },
        D5: {
          title: "Lunch Sponsor Day 1",
          description: "(non-exclusive)",
          price: "Rs 1,50,000",
          features: [],
          para: "Banner outside Banquet Hall acknowledging sponsorship with logo. Logo of Sponsor as Lunch Sponsor on Stage, Event Guide, Venue Banners, Newsletters",
        },
        D6: {
          title: "Lunch Sponsor Day 2",
          description: "(non-exclusive)",
          price: "Rs 1,10,000",
          features: [],
          para: "Banner outside Banquet Hall acknowledging sponsorship with logo. Logo of Sponsor as Lunch Sponsor on Stage, Event Guide, Venue Banners, Newsletters.",
        },
        D7: {
          title: "Refreshments Sponsor Day 1",
          description: "(non-exclusive)",
          price: "Rs 1,00,000",
          features: [],
          para: "Banner outside Banquet Hall acknowledging sponsorship with logo. Logo of Sponsor as Refreshments Sponsor on Stage, Event Guide, Venue Banners, Newsletters.",
        },
        D8: {
          title: "Refreshments Sponsor Day 2",
          description: "(non-exclusive)",
          price: "Rs 75,000",
          features: [],
          para: "Banner outside Banquet Hall acknowledging sponsorship with logo. Logo of Sponsor as Refreshments Sponsor on Stage, Event Guide, Venue Banners, Newsletters.",
        },
      },
    },
  },
  communicationOptions: {
    title: "E. Communication options",
    buttonDescription: "Select your options and",
    buttonText: "Add to Cart",
    options: {
      E: {
        // E1: {
        //   title: "Conduct a Workshop",
        //   description: "(15-min duration in parallel session)",
        //   price: "Rs 30,000",
        //   features: [
        //     "a. Topic and Presenter details will be included in the Event Guide, Website, Newsletter, Emails to participants and schedule displayed at Venue",
        //     "b. Schedule Committee will approve topic and schedule it on Day 1 or 2.",
        //     "c. Attendance is on voluntary basis.",
        //   ],
        //   para: "",
        // },
        E2: {
          title: "Make a Presentation",
          description:
            "(15-min duration in parallel session) (Only with Sponsorship)",
          price: "Rs 40,000",
          features: [
            "a. Publicity by Organisers through Event Guide, Website, Newsletter, Emails to participants.",
            "b. Organising Committee will decide on day, time slot and location.",
            "c. Attendance is on voluntary basis.",
          ],
          para: "",
        },
        E3: {
          title: "Newsletters Promo",
          price: "Rs 25,000",
          features: [
            "a. Company banner (300x300 px), 50 words and url link to 600 words online article in six direct-mail Event Newsletters to all participants.",
            "b. Article (up to 600 words and 2 images) can be hosted on IMR website.",
          ],
          para: "",
        },
        E4: {
          title: "Standee Banner Indoor",
          description: "(One 3x6 ft banner indoor display at the venue)",
          price: "Rs 12,000",
          features: [
            "a. Creative by customer. Production and installation by Organisers.",
          ],
          para: "",
        },
        E5: {
          title: "Large Standee Banner Outdoor",
          description: "(One 6x8 ft banner outdoor display at venue)",
          price: "Rs 30,000",
          features: [
            "a. Creative by customer. Production and installation by Organisers.",
          ],
          para: "",
        },
        E6: {
          title: "Literature Inserted in Delegate Bags",
          price: "Rs 30,000",
          features: [
            "a. One Brochure/ Literature (max 12 pp) or gift inserted in each Delegate Folder. (approx quantity 800).",
          ],
          para: "",
        },
        E7: {
          title: "Full Page Advertisement",
          description: "(running order) 213mm W x 277mm H Advt in Event Guide",
          price: "Rs. 40,000",
          features: ["", "", ""],
        },
        E8: {
          title: "Half Page Advertisement",
          description: "(Landscape) 124mm W x 194mm H Advt in Event Guide",
          price: "Rs. 25,000",
          features: ["", "", ""],
        },
        E9: {
          title: "Back Cover Advertisement",
          description: "213mm W x 277mm H Advt in Event Guide",
          price: "Rs. 1,00,000",
          features: ["", "", ""],
        },
        E10: {
          title: "Inside Front Cover Advertisement",
          description: "213mm W x 277mm H Advt in Event Guide",
          price: "Rs. 75,000",
          features: ["", "", ""],
        },
        E11: {
          title: "Inside Back Cover Advertisement",
          description: "213mm x 277mm Advt in Event Guide",
          price: "Rs. 60,000",
          features: ["", "", ""],
        },
      },
    },
    advertisementTitle: "Advertisement in the Event Guide.",
  },
  extraItems: {
    title: "F. Extra Items for Exhibition Stands on Hire/Order",
    buttonDescription: "Select your options and",
    buttonText: "Place Order",
    description:
      "A number of items are provided in each exhibition booth as part of the furnishings, like Tables, Chairs, Lights, Dustbin, Electric socket depending on the size of the booth. The following additional items can be ordered. These will be provided at your booth and include delivery, installation and removal charges for both days of the event inclusive.",
    options: {
      F: {
        F1: {
          title: "Literature Stand (H 124cm)",
          quantity: 1,
          price: 800,
        },
        F2: {
          title: "Information Counter (106cm L x 58cm W x 75cm H)",
          quantity: 1,
          price: 700,
        },
        F3: {
          title: "Set of Round Table and 3 chairs (70cm H x 90cm Dia)",
          quantity: 1,
          price: 2500,
        },
        F4: { title: "Cushion Chairs, each", quantity: 1, price: 500 },
        F5: {
          title: "Sofa 1-seat (White/ Black)",
          quantity: 1,
          price: 1500,
        },
        F6: {
          title: "Sofa 2-seat (White/ Black)",
          quantity: 1,
          price: 3000,
        },
        F7: {
          title: "Glass Counter, each (102cm L x 52cm W x 100cm H) ",
          quantity: 1,
          price: 3000,
        },
        F8: {
          title: "42-in LED with stand, with USB",
          quantity: 1,
          price: 2500,
        },
        F9: {
          title: "50-in LED with stand, with USB",
          quantity: 1,
          price: 3500,
        },
        F10: {
          title:
            "Printed Flex banners to cover 3 walls of 2x2m booth with frame - 156 sq ft @ Rs 65 p/sqft",
          quantity: 1,
          price: 10140,
        },
        F11: {
          title:
            "Printed Flex banners to cover 3 walls of 3x2m booth with frame - 180 sqft @ Rs 65 p/sqft",
          quantity: 1,
          price: 11700,
        },
        F12: {
          title:
            "Printed Flex banners to cover 3 walls of 6x2m booth with frame - 256 sqft @ Rs 65 p/sqft",
          quantity: 1,
          price: 16640,
        },
      },
    },
    totalDetails: [
      { label: "Total excluding GST", value: "Rs xxxxx.xx", id: 1 },
      { label: "GST 18%", value: "Rs xxxxx.xx", id: 2 },
      {
        label: "Total including GST",
        value: "Rs xxxxx.xx",
        id: 3,
        description: "GST 18% applicable in all cases (HSN Code 998596 )",
      },
    ],
    paymentTerms:
      "Payment Terms: 100% amount payable at the time of booking to confirm your selection.",
    refundRules: {
      title: "Refund Rules",
      rules: [
        `If any of the Business Meetings Packages (A1 to A6) are purchased and cancelled before 15 Sep ${new Date().getFullYear()}, we will refund the whole amount after deducting Rs 2000 and 10% of the purchase amount. Thereafter, no refunds are possible for Business Meetings Packages.`,
        `For all other options (Sponsorship, Exhibition, Branding, and Communications), refunds will be made up to 30 Sep ${new Date().getFullYear()} after deducting 25% of the total cost of the bill. Thereafter, no refunds are possible, except in case the event is cancelled by the Organisers.`,
      ],
    },
  },
  exampleItems: {
    exitem1: "Showcase (3 shown)",
    exitem2: "Wall flex banners of 2x2m booth",
    exitem3: "Wall flex banners of 3x2m booth",
    exitem4: "Cushion Chair",
    exitem5: "Literature Stand",
    exitem6: "Round Table",
    exitem7: "Glass Counter",
    exitem8: "Information Counter",
    exitem9: "LED TV with Stand",
  },
  bankDetails: {
    title: "Our Bank particulars",
    details: [
      { label: "Account Name:", value: " IMR Media Pvt Ltd" },
      { label: "Bank:", value: " Axis Bank" },
      { label: "IFSC Code:", value: "UTIB0003622" },
      {
        label: "Bank Branch:",
        value: " Sector 30, Star Mall, Gurgaon 122001",
      },
      { label: "Account No:", value: " 923020013921235" },
      { label: "SWIFT Code:", value: " AXISINBB" },
      { label: "Our GST No.", value: " 06AACCI7766G1ZD" },
    ],
  },
  fulfillingOrder: {
    title: "Fulfilling Your Orders",
    steps: [
      "Your Selection will show up as “Add-on” on your Profile Page Dashboard in the Members Area.",
      "Please fulfill the requirements of material, files, images, text, etc, required to be submitted by due date online.",
      "In case any material is required to be sent by email please send it to orders@defencepartners.in",
    ],
  },
};

export default pricelist;
